import { BasicRequest } from "./basicRequest";

export class UndeleteTransformationDefinitionRequest extends BasicRequest{
    public transformationDefinitionId! : number;
}